export const siteInfo = {
  name: "Akeelah 观影指南",
  tagline: "探索阿基拉和拼字大赛的完整观影指南",
  description: "深度解析电影《Akeelah and the Bee》的剧情、角色、教育意义与感人主题。这部励志电影讲述一位来自洛杉矶贫困社区的女孩如何凭借毅力与勇气登上全国拼写大赛舞台。",
  keywords: "akeelah and the bee,akeelah and the bee 剧情解析,akeelah and the bee 观后感,akeelah and the bee 教育意义,akeelah and the bee 角色分析,akeelah and the bee 拼写比赛,励志成长电影推荐",
  url: "https://akeelah-guide.com",
  locale: "zh_CN",
  foundingYear: 2024,
  email: "hello@akeelah-guide.com",
  phone: "+86 400-888-0000",
  address: "北京市朝阳区建国路88号",
  social: {
    weibo: "https://weibo.com/akeelahguide",
    wechat: "akeelah_guide",
    douban: "https://movie.douban.com/subject/akeelah",
  },
};

export const aboutContent = {
  brandIntro:
    "Akeelah 观影指南是一个专注于深度解读励志电影《Akeelah and the Bee》（阿基拉和拼字大赛）的中文内容平台。我们汇聚了数十位影评人和教育工作者，从剧情分析、角色解读、教育启示等多个维度，为观众提供全面而深入的观影指南。我们的使命是让每一位观众都能从这部电影中汲取力量，感受教育与坚持的魅力。",
  brandStory:
    "这个网站诞生于一次电影放映活动后的深夜讨论。我们发现，《Akeelah and the Bee》虽然是一部2006年的电影，但它所传递的关于教育公平、社区力量和个人成长的主题，在今天依然具有强烈的现实意义。于是，我们决定创建一个专门的中文平台，让更多中国观众能够深入了解这部电影的内涵，并将其中的启发应用到自己的生活和教育实践中。",
  reputation: [
    {
      metric: "50万+",
      label: "月访问用户",
    },
    {
      metric: "200+",
      label: "深度文章",
    },
    {
      metric: "4.9",
      label: "用户评分",
    },
    {
      metric: "30+",
      label: "合作影评人",
    },
  ],
  values: [
    {
      title: "深度解读",
      description: "每篇文章都经过多轮研究与打磨，力求为读者提供最有价值的观影视角。",
    },
    {
      title: "教育导向",
      description: "我们始终关注电影中的教育元素，帮助读者理解和应用影片传达的学习理念。",
    },
    {
      title: "社区共建",
      description: "鼓励读者参与讨论与分享，共同构建一个热爱电影、关注教育的社区。",
    },
    {
      title: "内容原创",
      description: "坚持原创内容生产，拒绝低质量搬运，维护中文电影评论的原创生态。",
    },
  ],
};

export const faqData = [
  {
    question: "《Akeelah and the Bee》讲了一个什么故事？",
    answer:
      "《Akeelah and the Bee》讲述了一位来自洛杉矶南部贫困社区的11岁女孩阿基拉·安德森（Akeelah Anderson），凭借惊人的拼写天赋和顽强的毅力，在导师拉勒比博士（Dr. Larabee）和社区的支持下，一路过关斩将，最终登上全国拼字大赛（Scripps National Spelling Bee）舞台的励志成长故事。",
  },
  {
    question: "这部电影适合什么年龄段观看？",
    answer:
      "这部电影适合7岁以上的所有观众。对于小学生和初中生来说，它可以激发学习兴趣和自信心；对于家长和教育工作者，它提供了关于教育方法和亲子关系的深刻思考；对于普通观众，它是一部温暖人心、充满正能量的佳作。",
  },
  {
    question: "电影中的拼字比赛是真实的吗？",
    answer:
      "是的，电影中描绘的斯克里普斯全国拼字大赛（Scripps National Spelling Bee）是美国真实存在的年度拼字比赛，始于1925年，至今仍在举办。电影虽然是虚构故事，但比赛的形式、规则和氛围都非常真实。",
  },
  {
    question: "这部电影获得了哪些奖项？",
    answer:
      "《Akeelah and the Bee》获得了多项提名和奖项，包括2007年NAACP形象奖最佳影片提名、青年艺术家奖最佳家庭影片提名等。电影在烂番茄上的新鲜度高达86%，观众评分超过80%。",
  },
  {
    question: "在哪里可以观看这部电影？",
    answer:
      "这部电影可以在多个流媒体平台上观看，包括Amazon Prime Video、Apple TV、Google Play Movies等。建议在观看前确认所在地区的可用性。",
  },
];